"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var NotificationContent_1 = require("./NotificationContent");

var frontend_layout_2 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_button_1 = require("@ryerson/frontend.button");

var StylesComponents_1 = require("./StylesComponents");

var HelperComponents_1 = require("./HelperComponents");

var HelperFunctions_1 = require("./HelperFunctions");

var Notification_1 = require("../Notification");

var Application_1 = require("../Application");

var AddToCartNotification = function AddToCartNotification(_ref) {
  var products = _ref.products,
      messageId = _ref.messageId,
      storeDirectory = _ref.storeDirectory;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, Notification_1.useNotifications)(),
      removeNotification = _ref3.removeNotification;

  var _ref4 = (0, Application_1.useApplication)(),
      isNative = _ref4.isNative,
      language = _ref4.localization.language;

  var content = NotificationContent_1.NotificationContent[language] || NotificationContent_1.NotificationContent.en;

  var renderPageContent = function renderPageContent() {
    var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var hasProducts = Array.isArray(products) && products.length > 0;

    var _ref5 = (0, HelperFunctions_1.getDisplayProps)(isMobile, isNative, theme),
        notificationProps = _ref5.notificationProps,
        headerProps = _ref5.headerProps,
        typeProps = _ref5.typeProps,
        buttonProps = _ref5.buttonProps;

    return (0, jsx_runtime_1.jsxs)(StylesComponents_1.Notification, Object.assign({
      id: "".concat(messageId)
    }, notificationProps, {
      children: [(0, jsx_runtime_1.jsx)(StylesComponents_1.NotificationHeader, Object.assign({}, headerProps, {
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          justifyContent: "space-between",
          children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
            children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, Object.assign({
              variant: "p"
            }, typeProps, {
              children: content.title
            })), hasProducts && (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
              type: isMobile ? "tertiary" : "secondary",
              children: [products.length, " ", content.products]
            })]
          }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, Object.assign({}, buttonProps, {
            onClick: function onClick() {
              removeNotification();
            }
          }))]
        })
      })), (0, jsx_runtime_1.jsx)(StylesComponents_1.NotificationsScrollable, {
        isMobile: false,
        children: hasProducts && products.map(function (product, index) {
          return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
            children: isMobile ? (0, jsx_runtime_1.jsx)(HelperComponents_1.MobileProductNotification, {
              product: product,
              index: index,
              storeDirectory: storeDirectory
            }) : (0, jsx_runtime_1.jsx)(HelperComponents_1.DesktopProductNotification, {
              product: product,
              index: index,
              storeDirectory: storeDirectory
            })
          }, index);
        })
      })]
    }));
  };

  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_2.Media, {
      lessThan: "lg",
      children: renderPageContent(true)
    }), (0, jsx_runtime_1.jsxs)(frontend_layout_2.Media, {
      greaterThanOrEqual: "lg",
      children: [" ", renderPageContent()]
    })]
  });
};

exports.default = AddToCartNotification;